export default __webpack_public_path__ + "static/BrandonGrotesque-LightItalic-c863498dd6c249cadf04a48a06c2f2cf.woff2";